module.exports = "/assets/dist/images/shop-logo.png?c615f2d532af9e66317826c24f15c9b7";